import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface FooterLink {
    labelKey: string;
    href: string;
    translationParams?: Record<string, string | number>;
}

export const FOOTER_LINKS: readonly FooterLink[] = [
    {
        labelKey: 'footer.copyright',
        href: 'https://www.siemens-healthineers.com/',
        translationParams: { year: new Date().getFullYear() }
    },
    {
        labelKey: 'footer.corporate-information',
        href: 'https://www.siemens-healthineers.com/corporate-info'
    },
    {
        labelKey: 'footer.privacy-notice',
        href: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy'
    },
    {
        labelKey: 'footer.cookie-notice',
        href: 'https://www.siemens-healthineers.com/cookie'
    },
    {
        labelKey: 'footer.terms-of-use',
        href: 'https://www.siemens-healthineers.com/terms-of-use'
    },
    {
        labelKey: 'footer.digital-id',
        href: 'https://www.siemens-healthineers.com/corporate/digital-services-act'
    }
];

@Component({
    selector: 'app-shared-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule]
})
export class FooterComponent {
    public readonly links = input<readonly FooterLink[]>(FOOTER_LINKS);
}
